module.exports = __webpack_public_path__ + "static/media/jaguar.b8dcd6bf.svg";